module.exports = __webpack_public_path__ + "fa-brands-400.woff2?5e2f92123d241cabecf0b289b9b08d4a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2
// module id = 223
// module chunks = 0